module.exports = __webpack_public_path__ + "media/universities/ESSEC-beae0465.png";